import type { email as it } from "../it/email.ts";

/** Email di avviso e di prova, nella lingua dell'istanza. */
export const email: typeof it = {
  "email.stack": (p: { stack: string }) => `Stack: ${p.stack}`,
  "email.stackSconosciuto": (p: { id: number }) => `stack ${p.id}`,
  "email.servizio": (p: { servizio: string }) => `Service: ${p.servizio}`,
  "email.regola": (p: { regola: string }) => `Rule: ${p.regola}`,
  "email.valore": (p: { valore: string }) => `Value reached: ${p.valore}%`,
  "email.da": (p: { quando: string }) => `From: ${p.quando}`,
  "email.fino": (p: { quando: string }) => `Until: ${p.quando}`,
  "email.apri": (p: { link: string }) => `Open in Portman: ${p.link}`,
  "email.oggetto": (p: { rientro: boolean; stack: string; servizio: string; regola: string }) =>
    `[Portman] ${p.rientro ? "resolved — " : ""}${p.stack} · ${p.servizio}: ${p.regola}`,
  "email.cpu": "CPU",
  "email.memoria": "memory",
  "email.sopraSoglia": (p: { nome: string; soglia: number; minuti: number }) =>
    `${p.nome} above ${p.soglia}% for ${p.minuti} minutes`,
  "email.senzaMisure": "No measurements for 5 minutes: the container is no longer running.",
  "email.oom": "killed for running out of memory (OOM)",
  "email.fermato": (p: { codice: number | null }) => `stopped unexpectedly (exit code ${p.codice})`,
  "email.silenzioArresti": "Further stops of this service in the next 30 minutes won't be emailed.",
  "email.silenzioOom": "Further OOMs of this service in the next 30 minutes won't be emailed.",
  "email.ripartito": "The container started again.",
  "email.rimastoFermo": "The container stayed stopped.",
  "email.provaOggetto": "[Portman] test email",
  "email.provaTesto": "This is a test email from Portman: alert settings are working.",
};
